import React from "react";
import { CalculateMethod } from "../input-methods/CalculateMethod";
import { ApartmentNumbersTable } from "../input-methods/ApartmentNumbersTable";
import BaseInputValidator from "../../../common/input-validators/BaseInputValidator";
import Field from "../../../../model/configurator/Field";
import { Calculation } from "../../../../../src/application/Contracts";
import InstallationType = Calculation.InstallationType;

interface SelfProps {
    selectedInstallationType: number;
    renderField: (field: any, additionalProps?: object, validator?: BaseInputValidator | undefined) => any;
    fields: { [key: string]: Field };
    readonly?: boolean;
    equivalentInStandardApartments: number;
}

export class MatchingTapWaterSystemSelection extends React.Component<SelfProps> {
    showForInstallationType = (installationType: InstallationType, selectedType: number | undefined = undefined): boolean => {
        return (selectedType ?? this.props.selectedInstallationType) === installationType;
    }

    getGrid = () => {
        return this.showForInstallationType(InstallationType.ApartmentsBlocks) ? 'step-inputs-row  grid-2' : '';
    }

    render() {
        return <>
            <div className={this.getGrid()}>
                <CalculateMethod selectedInstallationType={this.props.selectedInstallationType}
                    renderField={this.props.renderField}
                    readonly={this.props.readonly}
                    fields={this.props.fields} />

                {this.showForInstallationType(InstallationType.ApartmentsBlocks) && (
                    <div className={`card properties-card`}>
                        <div className={`card-body`}>
                            <ApartmentNumbersTable renderField={this.props.renderField}
                                fields={this.props.fields}
                                readonly={this.props.readonly}
                                equivalentInStandardApartments={this.props.equivalentInStandardApartments} />
                        </div>
                    </div>)}
            </div>
        </>
    }
}